import script from "./numberMatLeads.vue?vue&type=script&setup=true&lang=js"
export * from "./numberMatLeads.vue?vue&type=script&setup=true&lang=js"

import "./numberMatLeads.vue?vue&type=style&index=0&id=1ab30d52&lang=css"

const __exports__ = script;

export default __exports__